import { makeStyles, Theme, Typography } from "@material-ui/core"

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        background: 'linear-gradient(225.89deg,#fc5e22 -1.1%,#fc992c 99.53%) no-repeat',
        color: 'white',
        width: '100%',
        height: 30,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    circleTxt: {
        fontWeight: 'bold'
    }
}));

const EmpfehlungBlock: React.FC = () => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Typography variant='body2' className={classes.circleTxt} color='inherit'>UNSERE EMPFEHLUNG</Typography>
        </div>
    );
}

export default EmpfehlungBlock;